export default "__VITE_ASSET__CNxGS4hd__"